import { render } from "./tbd.vue?vue&type=template&id=c5b9798a"
import script from "./tbd.vue?vue&type=script&lang=js"
export * from "./tbd.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__